export const portfolio=[

    {
        image:'pimages/cataph.png',
        link:'https://portal.cataphract.co.uk',
        tech:'LARAVEL'

    },
    {
        image:'pimages/saral.png',
        link:'#',
        tech:'LARAVEL'

    },

    {
        image:'pimages/chitro.png',
        link:'https://chitrolab.com/',
        tech:'LARAVEL'
    },
     
    {
        image:'pimages/ca.png',
        link:'#',
        tech:'LARAVEL'
    },
    {
        image:'pimages/nestray.png',
        link:'https://nestray.com/',
        tech:'LARAVEL'
      
    },
    {
        image:'pimages/smoke.png',
        link:'#',
        tech:'LARAVEL'
      
    },
    

]


export const tech =[

    {
        image:'timages/r.png',
        name:'React Js'


    },
    {
        image:'timages/mui.png',
        name:'Material UI'


    },

    {
        image:'timages/c.png',
        name:'CSS 3'


    },

    {
        image:'timages/h.png',
        name:'HTML 5'


    },


]